import { render, staticRenderFns } from "./SampleAuditTrailHistory.vue?vue&type=template&id=139706b6"
import script from "./SampleAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./SampleAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports